import { LorebookVisibility } from "@next-platform/packages-ts-types";

export enum FORM_FIELDS {
  ID = "id",
  NAME = "name",
  DESCRIPTION = "description",
  AVATAR = "avatar_url",
  TAGS = "tags",
  VISIBILITY = "visibility",
  GUIDELINES = "guidelines",
  ENTRIES = "entries",
}

export const ENTRY_FORM_FIELDS = {
  ID: "id",
  NAME: "name",
  KEYWORDS: "keywords",
  CONTENT: "content",
  UPDATED_AT: "updatedAt",
};

export const PRIVATE_LOREBOOK_VISIBILITY = [LorebookVisibility.PRIVATE, LorebookVisibility.PERMANENTLY_PRIVATE] as const;

export const DEFAULT_LOREBOOK_VISIBILITY = LorebookVisibility.PRIVATE;

// Lorebook entry limit mirrored in backend to prevent oversized imports/uploads
export const MAX_LOREBOOK_ENTRIES = 5000;
export const LOREBOOK_ENTRY_LIMIT_MESSAGE = `Lorebooks can contain up to ${MAX_LOREBOOK_ENTRIES} entries.`;

// Lorebook validation limits
export const MIN_FIELD_LENGTH = 3;
export const MIN_PUBLIC_TAGS_COUNT = 2;
export const MIN_PUBLIC_LOREBOOK_ENTRIES = 5;

// Lorebook form field limits
export const MAX_LOREBOOK_NAME_LENGTH = 25;
export const MAX_LOREBOOK_DESCRIPTION_LENGTH = 100;

// Lorebook entry field limits
export const MAX_ENTRY_NAME_LENGTH = 50;
export const MAX_ENTRY_KEYWORD_LENGTH = 100;
export const MAX_ENTRY_KEYWORDS_COUNT = 12;
export const MAX_ENTRY_CONTENT_LENGTH = 2000;
